<template>
  <v-row>
    <v-col
      v-for="(item, i) in tabs"
      :key="i"
      cols="auto"
    >
      <v-btn
        :text="!tab_selected(item)"
        :to="`/tasks/${item.id}`"
      >
        {{ item.name }}
      </v-btn>
    </v-col>
    <v-spacer />
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TaskHeader',
  components: {},
  data() {
    return { loading: false, saving: false };
  },
  computed: {
    tabs() {
      return this.$enums.TASK_TABS;
    },
    id() {
      return this.$route.params.id;
    },
    tab_selected() {
      return (item) => {
        return this.id === item.id;
      };
    },
    ...mapGetters({})
  },
  methods: {}
};
</script>
